import { List, ListItemButton, Divider, Stack, Box, alpha, Typography } from "@mui/material";
import CustomPopover from "../../../components/custom-popover";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiButton from "src/components/core-components/mui/buttons/ByzMuiButton";
import { useTranslate } from "src/locales";

type Props = {
    open: HTMLElement | null;
    onClose: VoidFunction;
    officeList: any[];
    selectedId: number | null;
    onSelect: (id: number) => void;
    onConfirm: (id: number) => void;
};

export default function OfficeSelectionPopover({
    open,
    onClose,
    officeList,
    selectedId,
    onSelect,
    onConfirm,
}: Props) {
    const { t } = useTranslate();

    return (
        <CustomPopover
            open={open}
            onClose={onClose}
            sx={{
                width: 280,
                p: 2,
                '& .MuiPaper-root': {
                    borderRadius: 2,
                    boxShadow: (theme: any) => theme.customShadows?.z20 || '0 20px 40px -4px rgba(145, 158, 171, 0.24)',
                }
            }}
        >
            <ByzMuiTypography
                sx={{
                    color: '#0F1121',
                    fontSize: '16px',
                    fontWeight: 500,
                    mb: 2
                }}
            >
                {t("office-list")}
            </ByzMuiTypography>

            <Box sx={{ maxHeight: 300, overflow: 'auto' }}>
                <List disablePadding>
                    {officeList?.map((item) => (
                        <ListItemButton
                            key={item.ID}
                            selected={selectedId === item.ID}
                            onClick={() => {
                                if (item.ID !== null && item.ID !== selectedId) {
                                    onSelect(item.ID);
                                    onConfirm(item.ID);
                                }
                            }}
                            sx={{
                                py: 1,
                                px: 0,
                                borderRadius: 1,
                                '&.Mui-selected': {
                                    bgcolor: 'transparent',
                                    color: '#2979C3',
                                    fontWeight: 'bold',
                                    '&:hover': {
                                        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.5),
                                    },
                                },
                                '&:hover': {
                                    bgcolor: (theme) => alpha(theme.palette.grey[500], 0.3),
                                },
                            }}
                        >
                            <ByzMuiTypography variant="body1">
                                {item.OFFICE_NAME}
                            </ByzMuiTypography>
                        </ListItemButton>
                    ))}
                </List>
            </Box>

            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-start' }}>
                <Typography
                    onClick={onClose}
                    sx={{
                        color: '#2196F3',
                        fontFamily: 'Inter',
                        fontSize: '14px',
                        fontWeight: 500,
                        lineHeight: '20px',
                        cursor: 'pointer',
                        '&:hover': {
                            textDecoration: 'underline'
                        }
                    }}
                >
                    {t("close")}
                </Typography>
            </Box>
        </CustomPopover>
    );
}
